"use strict";import{IconClose as e}from"../src/elements/IconClose.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-close",e);
//# sourceMappingURL=sp-icon-close.js.map
